import React, { useState, useContext } from 'react';
import { Button, Select, Space, Upload, Alert } from 'antd';
import { ApplicationUIContext, Form, DrawerContent } from '@yuhuinc/ui-library';
import { UploadOutlined } from '@ant-design/icons';

import { getTranslatedString } from 'helpers/i18n';

const getFileFromEvent = (event) => {
  if (Array.isArray(event)) {
    return event;
  }

  return event?.fileList;
};

const UploadDocument = ({ onSubmit, onCancel }) => {
  const [form] = Form.useForm();
  const selectedFiles = Form.useWatch('file', form);
  const { isMobile } = useContext(ApplicationUIContext);
  const [hasError, setHasError] = useState(false);

  const onError = ({ errorFields }) => {
    if (errorFields.length > 1) {
      setHasError(true);
    }
  };

  return (
    <DrawerContent>
      {hasError && (
        <Alert message={getTranslatedString('errorsOnThisPage')} type="error" showIcon />
      )}
      <Form
        form={form}
        layout="vertical"
        size={isMobile && 'large'}
        gap={16}
        initialValues={{}}
        onFinish={onSubmit}
        onFinishFailed={onError}
      >
        <Form.Item
          valuePropName="fileList"
          name="file"
          getValueFromEvent={getFileFromEvent}
          rules={[
            {
              validator(_, value) {
                if (!value || value.length === 0) {
                  return Promise.reject(new Error(getTranslatedString('required')));
                }

                return Promise.resolve();
              },
              validateTrigger: 'onSubmit',
            },
          ]}
        >
          <Upload maxCount={1} beforeUpload={() => false}>
            {(!selectedFiles || selectedFiles.length === 0) && (
              <Button size={isMobile && 'large'} icon={<UploadOutlined />}>
                {getTranslatedString(
                  'landlordPortal.applicationManagement.applicationOverview.applicants.documents.uploadDocument'
                )}
              </Button>
            )}
          </Upload>
        </Form.Item>
        <Form.Item
          label={getTranslatedString(
            'landlordPortal.applicationManagement.applicationOverview.applicants.documents.documentType'
          )}
          name="document_type"
          rules={[
            {
              required: true,
              message: getTranslatedString('required'),
              validateTrigger: 'onSubmit',
            },
          ]}
        >
          <Select
            style={{
              width: '100%',
            }}
            placeholder={getTranslatedString(
              'landlordPortal.applicationManagement.applicationOverview.applicants.documents.select'
            )}
          >
            <Select.Option value="application">
              {getTranslatedString(
                'landlordPortal.applicationManagement.applicationOverview.applicants.documents.documentTypes.application'
              )}
            </Select.Option>
          </Select>
        </Form.Item>
        <Space size="middle">
          <Button type="primary" size={isMobile && 'large'} htmlType="submit">
            {getTranslatedString(
              'landlordPortal.applicationManagement.applicationOverview.applicants.documents.save'
            )}
          </Button>
          <Button size={isMobile && 'large'} htmlType="button" onClick={onCancel}>
            {getTranslatedString(
              'landlordPortal.applicationManagement.applicationOverview.applicants.documents.cancel'
            )}
          </Button>
        </Space>
      </Form>
    </DrawerContent>
  );
};

export default UploadDocument;
